<template>
    <div class="headerConciliationBuy">
        <h1>{{ $t('reconciliation.label.list.title') }}</h1>

        <v-data-table :headers="headers" :items="filteredConciliationBuy()" :header-props="{ class: 'red-header' }"
            :search="searchTerm" :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'" :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }">
            <template v-slot:top>
                <div style="margin-bottom: 50px">
                    <div class="row justify-space-between mx-auto no-padding">
                        <div class="col-md-5">
                            <v-text-field :label="$t('label.search.title')" :placeholder="$t('label.search.text')"
                                append-icon="mdi-magnify" dense outlined v-model="searchTerm">
                            </v-text-field>
                            <v-select :label="$t('reconciliation.label.state.title')" :placeholder="$t('reconciliation.label.state.text')"
                                v-model="selectedState" :items="stateOptions" dense outlined @change="filterByState">
                            </v-select>
                        </div>
                    </div>
                </div>
            </template>

            <!-- Otros slots -->
            <template v-slot:[`item.date`]="{ item }">
                <span class="custom-font">{{ formattedDate(item.date) }}</span>
            </template>
                <template v-slot:[`item.reasonPurchase`]="{ item }">
                    <span class="custom-font">{{ item.reasonPurchase}}</span>
                </template>
            <template v-slot:[`item.totalValue`]="{ item }">
                <span class="custom-font">{{ (formatMoney(item.totalValue)) }}</span>
            </template>
            <template v-slot:[`item.transactionStateDto.stateName`]="{ item }">
                <span class="custom-font">{{ item.transactionStateDto.stateName }}</span>
            </template>

            <template v-slot:[`item.action`]="{ item }">
                <div class="actions" style="display: flex; align-items: center;">

                    <purchaseReconciliation :status="item.activeDialogClient" :changeStateProps="item"
                        style="margin-left:1vh;"></purchaseReconciliation>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import purchaseReconciliation from "@/views/purchase_reconciliation/pages/detail_change_state/detail_change_state_page.vue";
import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

import {
    PURCHASERECONCILIATION_M,
    GET_STATE_LOADING,
    ACTION_GET_PURCHASERECONCILIATION,
    GET_PURCHASERECONCILIATION
} from "@/views/purchase_reconciliation/store/types/types.js"

export default {
    name: "listCategoriaComponent",
    components: {
        purchaseReconciliation
    },

    data() {
        return {
            searchTerm: "",
            stateOptions: [],
            selectedState: null,
            searchIdentificationNumber: ''
        };
    },

    async mounted() {
        await this.getActionConciliationBuy();

        this.stateOptions = [
            { text: 'Todos', value: null },
            ...this.purchaseReconciliation.map(item => ({
                text: item.transactionStateDto.stateName,
                value: item.transactionStateDto.stateName
            })).filter((value, index, self) =>
                self.findIndex(option => option.value === value.value) === index
            )
        ];

        this.selectedState = this.stateOptions[0].value;

        EventBus.$on('reload-purchaseReconciliation', this.reloadConciliationBuy);
        EventBus.$on('reload-update-purchaseReconciliation', this.reloadConciliationBuy);
    },

    watch: {
        search() {
            this.searchTerm = event.target.value;
        },
        selectedState() {
            this.filteredConciliationBuy();
        },
        searchIdentificationNumber() {
            this.filteredConciliationBuy();
        }
    },

    methods: {
        ...mapActions({
            getActionConciliationBuy: `${PURCHASERECONCILIATION_M}${ACTION_GET_PURCHASERECONCILIATION}`,
        }),

        async reloadConciliationBuy() {
            await this.getActionConciliationBuy();
        },

        formatMoney(number) {
            return '$' + number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        formattedDate(date) {
            return moment(date).format('YYYY-MM-DD');
        },

        filterByState() {
            this.filteredConciliationBuy();
        },

        filteredConciliationBuy() {
            const normalizedSearchTerm = this.searchTerm.toUpperCase();

            return this.purchaseReconciliation.filter(item => {
                const fields = [
                    item.date ? item.date.toString() : "",
                    item.reasonPurchase ? item.reasonPurchase.toString() : "",
                    item.totalValue ? item.totalValue.toString() : "",
                    item.transactionStateDto?.stateName ? item.transactionStateDto.stateName.toString() : "",
                ];

                const matchesState = this.selectedState ? item.transactionStateDto.stateName === this.selectedState : true;
                const matchesFields = fields.some(field => field.toUpperCase().includes(normalizedSearchTerm));


                return matchesState && matchesFields;
            });
        },

    },
    computed: {
        ...mapGetters({
            purchaseReconciliation: [`${PURCHASERECONCILIATION_M}${GET_PURCHASERECONCILIATION}`],
            loading: [`${PURCHASERECONCILIATION_M}${GET_STATE_LOADING}`]
        }),

        headers() {
            return [
                {
                    text: this.$t('reconciliation.label.table.date'),
                    value: "date",
                    align: "center",
                    sortable: false,
                    class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
                },
                {
                    text: this.$t('reconciliation.label.table.reasonPurchase'),
                    value: "reasonPurchase",
                    align: "center",
                    sortable: false,
                    class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
                },
                {
                    text: this.$t('reconciliation.label.table.totalValue'),
                    value: "totalValue",
                    sortable: false,
                    align: "center",
                    class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
                },
                {
                    text: this.$t('reconciliation.label.table.state'),
                    value: "transactionStateDto.stateName",
                    align: "center",
                    sortable: false,
                    class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
                },
                {
                    value: "action",
                    align: "center",
                    sortable: false,
                    class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
                },
            ];
        },
    }
};
</script>

<style lang="css" scoped>
.headerConciliationBuy h1 {
    margin-bottom: 30px;
}

.headerConciliationBuy {
    display: flex;
    gap: 40px;
    flex-direction: column;
    margin-top: 20px;
    margin-left: 20px;
}

.actions v-icon {
    font-size: 24px;
}

.custom-font {
    font-size: 20px;
}

body {
    font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: "Amsi Pro", sans-serif;
    color: #2d0049;
    font-weight: normal;
}

.btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 19px;
}




.actions {
    display: flex;

}

img {
    width: 3rem;
    height: 3rem;
}

@media screen and (max-width: 414px) {

    h1 {
        font-size: 3vh;
        margin-left: 2vh
    }

    .custom-font {
        font-size: 13px;
    }

    img {
        margin-top: 18px;
        margin-bottom: auto;
        width: 3rem;
        height: 3rem;
    }
}

@media screen and (min-width: 414px) {

    h1 {
        font-size: 4vh;
        margin-left: 2vh
    }

}

@media screen and (max-width: 280px) {

    h1 {
        font-size: 3vh;
        margin-left: 2vh
    }

    h2 {
        font-size: 2vh;
    }

    .custom-font {
        font-size: 13px
    }

    img {
        margin-top: 20px;
        margin-bottom: 10px;
        width: 3rem;
        height: 3rem;
    }
}
</style>